import Vue from 'vue'
import Router from 'vue-router'
import lsfChat2 from '@/pages/official/chatprod'
import chatDev from '@/pages/official/chatdev'
import chatassistant from "@/pages/official/chatassistant"


import store from "../store";

import {getUserConfig} from "@/utils/api";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.meta.scrollTop) {
        to.meta.scrollEl.scrollTop = to.meta.scrollTop
      }
      return {
        x: 0,
        y: to.meta.scrollTop || 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: lsfChat2
    }, {
      path: '/dev',
      name: 'dev',
      component: chatDev
    }, {
      path: '/prod',
      name: 'prod',
      component: lsfChat2
    }, {
      path: '/assistant',
      name: 'assistant',
      component: chatassistant
    }
  ]
})
router.beforeEach((to, from, next) => {
  next()
})

function setBaseInfo(next, to, joinAssociateCode) {
  getUserConfig().then(res => {
    if (res && res.data.detail) {
      store.commit("mystate/setEnterprise", res.data.enterprise);
      store.commit("mystate/setPageTitle", res.data.detail.title);
      document.title = res.data.detail.title
      store.commit("mystate/setQuestionDoc", res.data.detail.questionDoc);
      store.commit(
        "mystate/setBannerList",
        res.data.detail.bannerUrlList
      );
      store.commit("mystate/setTabList", res.data.detail.navigateBarList);
      store.commit("mystate/setReportBanner", [res.data.yjReportType, res.data.thirdReportType]);
      if (joinAssociateCode) {

        next({
          path: to.path
        })
      } else {
        next()
      }
    }
  }).catch(() => {
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js